import {MODES, DESTINATIONS, MAX_HEIGHT, MAX_WIDTH} from './constants';

const validModes = values(MODES);
const validDestinations = values(DESTINATIONS);

export const rules = {
  height: {
    test (value) {
      if (!isNumber(value)) {
        throw new Error('Height must be a number.');
      }
      if (value <= 1 || value > MAX_HEIGHT) {
        throw new Error(`Height must be between 1 and ${MAX_HEIGHT}`);
      }
    }
  },
  width: {
    test (value) {
      if (!isNumber(value)) {
        throw new Error('Width must be a number.');
      }
      if (value <= 1 || value > MAX_WIDTH) {
        throw new Error(`Width must be between 1 and ${MAX_WIDTH}`);
      }
    }
  },
  mode: {
    test (value) {
      if (validModes.indexOf(value) === -1) {
        throw new Error(`Unknown mode ${value}`);
      }
    }
  },
  destination: {
    test (value) {
      if (validDestinations.indexOf(value) === -1) {
        throw new Error(`Unknown mode ${value}`);
      }
    }
  }
};

function isNumber (val) {
  return !isNaN(Number(val));
}

// Can't invest too much time designing this house of cards... Vue coming soon!
export class Validator {
  constructor (rules) {
    this.rules = rules;
  }
  validate (key, value) {
    this.rules[key].test(value);
  }
}

function values (o) {
  return Object.keys(o).map(k => o[k]);
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/settings/SettingsValidator.js